var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M15 12v-2h-5V8h5V6l3 3zm-1-1v4H9v3l-6-3V2h11v5h-1V3H5l4 2v9h4v-3z"}})}
var staticRenderFns = []

export { render, staticRenderFns }